import { createBrowserClient } from "@supabase/ssr";
import type { Database } from "../types";

export const createClient = () =>
  createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  );

export async function getActiveJourney(userId: string) {
  const supabase = createClient();

  const { data: user, error: userError } = await supabase
    .from("users")
    .select(`
      active_journey_id,
      active_journey:home_buying_journeys!users_active_journey_id_fkey (
        id,
        name,
        budget,
        city,
        state,
        credit_score,
        down_payment,
        property_types,
        min_bedrooms,
        min_bathrooms,
        neighborhoods,
        saved_search_sources,
        last_step,
        cal_link,
        pre_approval_amount,
        created_at,
        updated_at,
        primary_buyer:users!fk_primary_buyer (
          first_name,
          last_name,
          email
        )
      )
    `)
    .eq("id", userId)
    .single();

  if (userError) {
    console.error("Error fetching active journey:", userError);
    return null;
  }

  return user?.active_journey ?? null;
}
